import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'isIn',
    standalone: false
})
export class IsInPipe implements PipeTransform {
  transform<T>(value: T, arr: Array<T>): boolean {
    return arr.includes(value);
  }
}
